/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {pick} from 'lodash'
import {homeMock} from './mock'

export const getHomepage = createAsyncThunk(
  'LuckFomo/getHomepage',
  async (p: any, store: any) => {
    // return homeMock
    const resp = await http.post(
      '/live/gift/treasure_fomo_lottery_homepage',
      {...p},
      {
        store: window.store,
      }
    )
    return resp?.data?.data
  }
)

export const getNotice = createAsyncThunk(
  'LuckFomo/getNotice',
  async (p: any, store: any) => {
    // return homeMock
    const resp = await http.post(
      '/live/gift/treasure_fomo_lottery_homepage',
      {...p, from: 'notice'},
      {
        store: window.store,
      }
    )
    return resp?.data?.data
  }
)

export const getTotalRank = createAsyncThunk(
  'LuckFomo/getTotalRank',
  async (p: any, store: any) => {
    // return homeMock?.total_rank
    const resp = await http.post(
      '/live/gift/treasure_fomo_lottery_homepage',
      {...p, from: 'total_rank'},
      {
        store: window.store,
      }
    )
    return resp?.data?.data?.total_rank
  }
)

export const getTreasureRank = createAsyncThunk(
  'LuckFomo/getTreasureRank',
  async (p: any, store: any) => {
    // return homeMock
    const resp = await http.post(
      '/live/gift/treasure_fomo_lottery_homepage',
      {...p, from: 'treasure_rank'},
      {
        store: window.store,
      }
    )
    return resp?.data?.data
  }
)

export const getDailyRank = createAsyncThunk(
  'LuckFomo/getDailyRank',
  async (p: any, store: any) => {
    // return new Promise((res) => {
    //   setTimeout(() => {
    //     res(homeMock as any)
    //   }, 1000)
    // })
    const resp = await http.post(
      '/live/gift/treasure_fomo_lottery_homepage',
      {...p, from: 'daily_rank'},
      {
        store: window.store,
      }
    )
    return resp?.data?.data
  }
)

const initialState = {
  homepage: null,
  notice: null,
  total_rank: null,
  treasure_rank: null,
  daily_rank: null,
}

export const LuckFomoSlice = createSlice({
  name: 'LuckFomo',
  initialState,
  reducers: {
    setCountdown: (state, action: PayloadAction<Record<string, number>>) => {
      Object.assign(state, {
        homepage: {
          ...state.homepage,
          ...pick(action.payload, ['add_countdown', 'countdown']),
          is_show_transform: false,
          is_first: false,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomepage.fulfilled, (state, action) => {
      const data = action.payload || {}
      state.homepage = {...data, date_list: data?.date_list?.reverse?.() || []}
    })
    builder.addCase(getNotice.fulfilled, (state, action) => {
      const data = action.payload
      state.notice = data
    })
    builder.addCase(getTotalRank.fulfilled, (state, action) => {
      const data = action.payload
      state.total_rank = data
    })
    builder.addCase(getTreasureRank.fulfilled, (state, action) => {
      const data = action.payload
      state.treasure_rank = data
    })
    builder.addCase(getDailyRank.fulfilled, (state, action) => {
      const data = action.payload
      state.daily_rank = {
        data: data?.daily_rank,
        rewards: data?.daily_rank_rewards,
      }
    })
  },
})

export default LuckFomoSlice.reducer

export const LuckFomoSliceActions = LuckFomoSlice.actions

export const useReducerState = () => {
  const data = useSelector((state) => {
    return state.LuckFomo
  })
  return data
}
